import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import FirstLogin from "./pages/FirstLogin/FirstLogin";
import { UserContext } from "./Components/Contexts";
import { ResetPassword } from "./pages/ResetPassword/ResetPassword";

// Stylesheet
import "./App.scss";
import Utils from "./Components/utils";

function App() {
  const [isLogedIn, setLogedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  const [accounts, setAccounts] = useState([]);
  const account = accounts?.[0] ?? null;
  const [regional, setRegional] = useState(null);
  const [area, setArea] = useState(null);

  let user = null;

  useEffect(() => {
    document.title = "Friboi";
    getLogedInUser();
    hydrateAccountsFromStorage
  }, []);

  useEffect(() => {}, [isLogedIn]);

  const hydrateAccountsFromStorage = () => {
    const savedMulti = JSON.parse(localStorage.getItem("accounts") || "[]");
    const savedSingle = JSON.parse(localStorage.getItem("account") || "null");

    if (Array.isArray(savedMulti) && savedMulti.length) {
      setAccounts(savedMulti);
    } else if (savedSingle) {
      setAccounts([savedSingle]); 
    }
  };

  useEffect(() => {
    localStorage.setItem("accounts", JSON.stringify(accounts || []));
    if (accounts?.[0]) {
      localStorage.setItem("account", JSON.stringify(accounts[0]));
    } else {
      localStorage.removeItem("account");
    }
  }, [accounts]);

  const getLogedInUser = async () => {
    const storage = await localStorage.getItem("logedInUser");

    if (storage) {
      user = await Utils.getUserData();
      setLogedIn(user);
    } else {
      setLoading(false);
    }
  };

  if (!isLogedIn) {
    return (
      <div className='App'>
        {loading ? (
          <div className='loading'></div>
        ) : (
          <Router>
            <Switch>
              <Route path='/forgotpassword' component={ForgotPassword} />
              <Route path='/firstlogin' component={FirstLogin} />
              <Route path='/recover/:hash' component={ResetPassword} />
              <Route path='/'>
                <Login />
              </Route>
            </Switch>
          </Router>
        )}
      </div>
    );
  } else {
    return (
      <div className='App'>
        <UserContext.Provider value={{ isLogedIn, accounts, setAccounts, account, setAccount: (acc) => setAccounts(acc ? [acc] : []), }}>
          <Router>
            <Home />
          </Router>
        </UserContext.Provider>
      </div>
    );
  }
}

export default App;
